const { parseGa4PageType } = require('../constants');

/**
 * Event for Google Analytics 4.
 *
 * @typedef {object} EventGA4
 * @property {string} event - Event ID, always 'eventga4'
 * @property {string} eventga4_name - The name of the event
 * @property {string} page_type - The type of page. Ex: 'category', 'home'...
 * @property {string} page_title - The title of the page. Ex: 'REBAJAS BIMBA Y
 * LOLA España | Tienda online oficial'...
 * @property {string} page_location - The absolute url of the page
 * @property {string} shopByL_u - The country. Ex: 'ES', 'MX'...
 * @property {string} language - The language. Ex: 'es', 'gl'...
 * @property {string} store_id - The ID of the shop where the assisted shopping
 * has been done.
 * @property {string} sales_person_id - The ID of the person who has realized an
 * assisted shopping.
 * @property {string} user_id - The ID of the customer
 * @property {string} user_logged_in - 'yes' or 'no'
 * @property {string} user_agent: - The version of the device. Only for web.
 * @property {string} device_type - The type of device. Ex: 'web', 'app_ios'...
 */

/**
 * Create an event ready for pushing to dataLayers
 * @param {string} type The type of the event
 * @param {string} name The name of the event
 * @param {Object} props The props needed for a specific event
 * @returns {EventGA4} - The new event
 */
function createEventGA4(type, name, props) {
  /**
   * Common variables of every GA4 event
   * @link https://byl.atlassian.net/wiki/spaces/DATA/pages/3716743383/Comercio+electr+nico+GA4+WEB+y+APP
   */
  const generalVariables = {
    page_type: parseGa4PageType(gaInfo.pageType) ?? '',
    page_title: gaInfo.pageName ?? document.title,
    page_location: gaInfo.pageUrl,
    shopByL_u: gaInfo.shopByL,
    language: gaInfo.language,
    store_id: gaInfo.StoreId,
    sales_person_id: gaInfo.SalesPersonId,
    user_id: gaInfo.userId,
    user_logged_in: gaInfo.user_logged_in,
    user_agent: gaInfo.deviceVersion,
    device_type: gaInfo.deviceType,
  };

  return {
    event: type || 'eventga4',
    eventga4_name: name,
    ...generalVariables,
    ...props,
  };
}

module.exports = {
  createEventGA4,
};
